<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Titre</label>
      </div>
      <input v-model="dataForm.titre"
             class="form-control"
             name="article_titre"
             placeholder="Donnez un titre à l'article"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Contenu</label>
      </div>
      <textarea v-model="dataForm.contenu"
                class="form-control"
                name="article_contenu"
                placeholder="Saisissez le contenu de l'article">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Auteur</label>
      </div>
      <input v-model="dataForm.auteur"
             class="form-control"
             name="article_auteur"
             placeholder="Saisissez l'auteur de l'article"
             type="text">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Update",
  props: {
    article: {
      type: Object
    }
  },
  data() {
    return {
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        article_id: '',
        titre: '',
        contenu: '',
        auteur: '',
        table: 'articles',
        table_id: this.article.article_id,
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosPutData',
    ]),
    onSubmit() {
      this.resetDefaultValues()
      this.axiosPutData(this.dataForm)
          .then((data) => {
            if(data.status === 204)
              this.messageSuccess = "Article modifié avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de la modification de l'article !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de la modification de l'article !"
          })
    },
    resetDefaultValues() {
      if(this.dataForm.titre === '')
        this.dataForm.titre = this.article.titre
      if(this.dataForm.auteur === '')
        this.dataForm.auteur = this.terrain.auteur
      if(this.dataForm.contenu === '')
        this.dataForm.contenu = this.terrain.contenu
    },
    setDefaultValues() {
      const article = Object.assign({}, this.article);
      this.dataForm.titre = article.titre
      this.dataForm.auteur = article.auteur
      this.dataForm.contenu = article.contenu
    }
},
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    this.setDefaultValues()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/articles/components/Update.vue